import { combineReducers } from "redux"
import getAggregateSiteAssessmentInfoReducer from "./getAggregateSiteAssessmentInfoReducer"
import getUploadAggregateFileReducer from "./getUploadAggregateFileReducer"

const aggregateSiteAssessmentInfoReducer = combineReducers({
    getAggregateSiteAssessmentInfo: getAggregateSiteAssessmentInfoReducer,
    uploadAggregateFile: getUploadAggregateFileReducer
})

export default aggregateSiteAssessmentInfoReducer